<app-header></app-header>
<router-outlet></router-outlet>
<app-footer [backgroundColor]="homeSection ? 'grey' : ''"></app-footer>
<div class="custom-overlay" *ngIf="showSpinner">
    <div class="center">
        <mat-spinner> </mat-spinner>
    </div>
</div>